export const matchesPath = (path, pattern) => {
	// Remove deny prefix if present
	const cleanPattern = pattern.startsWith('!') ? pattern.slice(1) : pattern;
	// Exact match
	if (cleanPattern === path) return true;
	// Wildcard match
	if (cleanPattern.endsWith('/*')) {
		const basePath = cleanPattern.slice(0, -2);
		return path.startsWith(basePath + '/') || path === basePath;
	}
	return false;
};

export const hasPermission = (path, paths) => {
	const isDenied = paths.some(
		(pattern) => pattern.startsWith('!') && matchesPath(path, pattern)
	);
	if (isDenied) return false;

	const isAllowed = paths.some(
		(pattern) => !pattern.startsWith('!') && matchesPath(path, pattern)
	);

	return isAllowed;
};
